
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("5tKh7", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");


var $jmjWc = parcelRequire("jmjWc");








var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $6mKj3 = parcelRequire("6mKj3");


var $7aRa9 = parcelRequire("7aRa9");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4e2549f598bdb9fe$var$Placeholder = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(8);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { dynamicCoverImageHeight: dynamicCoverImageHeight, ...__cmpldp } = __cmplp;
        const t3 = `${__cmplp.dynamicCoverImageHeight}px`;
        let t4;
        if ($[3] !== t3) {
            t4 = (0, $7sObp.default)(t3);
            $[3] = t3;
            $[4] = t4;
        } else t4 = $[4];
        let t5;
        if ($[5] !== __cmpls || $[6] !== t4) {
            t5 = {
                ...__cmpls,
                "--_1isxe5u": t4
            };
            $[5] = __cmpls;
            $[6] = t4;
            $[7] = t5;
        } else t5 = $[7];
        t1 = /*#__PURE__*/ $42omo.createElement(C, {
            ...__cmpldp,
            style: t5,
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_11q7ysee _2rkofajl _kqswh2mm _1bsb1osq _4t3i1v90",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $4e2549f598bdb9fe$var$placeholderStyles = null;
const $4e2549f598bdb9fe$export$6ab910d41613f405 = (0, $7aRa9.withFlags)((props)=>{
    if (!props.hasCoverPicture) return null;
    if ((0, $6mKj3.expValEquals)('confluence_page_cover_picture_css_migration', 'isEnabled', true)) return /*#__PURE__*/ $42omo.createElement("div", {
        style: {
            height: props.dynamicCoverImageHeight ? `${props.dynamicCoverImageHeight}px` : undefined
        },
        className: (0, $gMc0m.default)([
            "_2rko12b0 _kqswh2mm _bfhkysee _1bsb1osq"
        ])
    });
    return /*#__PURE__*/ $42omo.createElement($4e2549f598bdb9fe$var$Placeholder, null);
});



const $7cc006105e2a4093$export$cc835f6c4a40c9c0 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "6TpAT",
    name: "LazyEditorPageCoverPicture",
    loader: async ()=>{
        return (await (parcelRequire("42HWG"))).EditorPageCoverPicture;
    },
    loading: (0, $4e2549f598bdb9fe$export$6ab910d41613f405)
});



var $i5zxs = parcelRequire("i5zxs");

const $fdbc267ab6414ddb$var$EditorPageCoverPictureEntryComponent = (t0)=>{
    const $ = (0, $frIzR.c)(49);
    const { contentId: contentId, isPublishingContent: isPublishingContent, contentType: contentType, userOffline: userOffline, coverPictureState: coverPictureState, isUnpublishedDraft: isUnpublishedDraft, floatingToolbarButtonStyle: floatingToolbarButtonStyle, isFixedWidthImageOption: isFixedWidthImageOption, width: width, dynamicCoverImageHeight: dynamicCoverImageHeight, isReadOnly: isReadOnly, hasCoverPicture: hasCoverPicture, contentPropertyKey: contentPropertyKey, isSmartSpaceOverview: isSmartSpaceOverview, aiSuggestedUnsplashImages: aiSuggestedUnsplashImages, isUnsplash: isUnsplash, aiHeaderImageStatus: aiHeaderImageStatus, aiHeaderImageFileId: aiHeaderImageFileId, aiHeaderImageError: aiHeaderImageError, generateAIHeaderImage: generateAIHeaderImage, setAIHeaderImageStatus: setAIHeaderImageStatus, isSmartCreate: isSmartCreate } = t0;
    if (hasCoverPicture) {
        const t1 = isFixedWidthImageOption ? "relative" : "absolute";
        let t2;
        if ($[0] !== t1) {
            t2 = {
                position: t1,
                left: "0px",
                right: "0px"
            };
            $[0] = t1;
            $[1] = t2;
        } else t2 = $[1];
        let t3;
        if ($[2] !== aiHeaderImageError || $[3] !== aiHeaderImageFileId || $[4] !== aiHeaderImageStatus || $[5] !== aiSuggestedUnsplashImages || $[6] !== contentId || $[7] !== contentPropertyKey || $[8] !== contentType || $[9] !== coverPictureState || $[10] !== dynamicCoverImageHeight || $[11] !== floatingToolbarButtonStyle || $[12] !== generateAIHeaderImage || $[13] !== hasCoverPicture || $[14] !== isFixedWidthImageOption || $[15] !== isPublishingContent || $[16] !== isReadOnly || $[17] !== isSmartCreate || $[18] !== isSmartSpaceOverview || $[19] !== isUnpublishedDraft || $[20] !== isUnsplash || $[21] !== setAIHeaderImageStatus || $[22] !== userOffline || $[23] !== width) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7cc006105e2a4093$export$cc835f6c4a40c9c0), {
                contentId: contentId,
                isPublishingContent: isPublishingContent,
                contentType: contentType,
                userOffline: userOffline,
                hasCoverPicture: hasCoverPicture,
                contentPropertyKey: contentPropertyKey,
                isSmartSpaceOverview: isSmartSpaceOverview,
                coverPictureState: coverPictureState,
                isUnpublishedDraft: isUnpublishedDraft,
                floatingToolbarButtonStyle: floatingToolbarButtonStyle,
                width: width,
                dynamicCoverImageHeight: dynamicCoverImageHeight,
                isReadOnly: isReadOnly,
                aiSuggestedUnsplashImages: aiSuggestedUnsplashImages,
                isUnsplash: isUnsplash,
                isFixedWidthImageOption: isFixedWidthImageOption,
                aiHeaderImageStatus: aiHeaderImageStatus,
                aiHeaderImageFileId: aiHeaderImageFileId,
                aiHeaderImageError: aiHeaderImageError,
                generateAIHeaderImage: generateAIHeaderImage,
                isSmartCreate: isSmartCreate,
                setAIHeaderImageStatus: setAIHeaderImageStatus
            });
            $[2] = aiHeaderImageError;
            $[3] = aiHeaderImageFileId;
            $[4] = aiHeaderImageStatus;
            $[5] = aiSuggestedUnsplashImages;
            $[6] = contentId;
            $[7] = contentPropertyKey;
            $[8] = contentType;
            $[9] = coverPictureState;
            $[10] = dynamicCoverImageHeight;
            $[11] = floatingToolbarButtonStyle;
            $[12] = generateAIHeaderImage;
            $[13] = hasCoverPicture;
            $[14] = isFixedWidthImageOption;
            $[15] = isPublishingContent;
            $[16] = isReadOnly;
            $[17] = isSmartCreate;
            $[18] = isSmartSpaceOverview;
            $[19] = isUnpublishedDraft;
            $[20] = isUnsplash;
            $[21] = setAIHeaderImageStatus;
            $[22] = userOffline;
            $[23] = width;
            $[24] = t3;
        } else t3 = $[24];
        let t4;
        if ($[25] !== t2 || $[26] !== t3) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                "data-testid": "has-cover-picture-component",
                style: t2
            }, t3);
            $[25] = t2;
            $[26] = t3;
            $[27] = t4;
        } else t4 = $[27];
        return t4;
    }
    let t1;
    if ($[28] !== aiHeaderImageError || $[29] !== aiHeaderImageFileId || $[30] !== aiHeaderImageStatus || $[31] !== aiSuggestedUnsplashImages || $[32] !== contentId || $[33] !== contentPropertyKey || $[34] !== contentType || $[35] !== coverPictureState || $[36] !== dynamicCoverImageHeight || $[37] !== floatingToolbarButtonStyle || $[38] !== generateAIHeaderImage || $[39] !== hasCoverPicture || $[40] !== isPublishingContent || $[41] !== isReadOnly || $[42] !== isSmartCreate || $[43] !== isSmartSpaceOverview || $[44] !== isUnpublishedDraft || $[45] !== setAIHeaderImageStatus || $[46] !== userOffline || $[47] !== width) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": "no-cover-picture-component"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7cc006105e2a4093$export$cc835f6c4a40c9c0), {
            contentId: contentId,
            isPublishingContent: isPublishingContent,
            contentType: contentType,
            userOffline: userOffline,
            hasCoverPicture: hasCoverPicture,
            contentPropertyKey: contentPropertyKey,
            isSmartSpaceOverview: isSmartSpaceOverview,
            coverPictureState: coverPictureState,
            isUnpublishedDraft: isUnpublishedDraft,
            floatingToolbarButtonStyle: floatingToolbarButtonStyle,
            width: width,
            dynamicCoverImageHeight: dynamicCoverImageHeight,
            isReadOnly: isReadOnly,
            aiSuggestedUnsplashImages: aiSuggestedUnsplashImages,
            aiHeaderImageStatus: aiHeaderImageStatus,
            aiHeaderImageFileId: aiHeaderImageFileId,
            aiHeaderImageError: aiHeaderImageError,
            generateAIHeaderImage: generateAIHeaderImage,
            setAIHeaderImageStatus: setAIHeaderImageStatus,
            isSmartCreate: isSmartCreate
        }));
        $[28] = aiHeaderImageError;
        $[29] = aiHeaderImageFileId;
        $[30] = aiHeaderImageStatus;
        $[31] = aiSuggestedUnsplashImages;
        $[32] = contentId;
        $[33] = contentPropertyKey;
        $[34] = contentType;
        $[35] = coverPictureState;
        $[36] = dynamicCoverImageHeight;
        $[37] = floatingToolbarButtonStyle;
        $[38] = generateAIHeaderImage;
        $[39] = hasCoverPicture;
        $[40] = isPublishingContent;
        $[41] = isReadOnly;
        $[42] = isSmartCreate;
        $[43] = isSmartSpaceOverview;
        $[44] = isUnpublishedDraft;
        $[45] = setAIHeaderImageStatus;
        $[46] = userOffline;
        $[47] = width;
        $[48] = t1;
    } else t1 = $[48];
    return t1;
};
const $fdbc267ab6414ddb$export$e8a47c72fec9e984 = (props)=>{
    const $ = (0, $frIzR.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [
            (0, $i5zxs.CoverPictureStateContainer)
        ];
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).PAGE_EXTENSIONS
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: t0
        }, (coverPictureState)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($fdbc267ab6414ddb$var$EditorPageCoverPictureEntryComponent, {
                ...props,
                coverPictureState: coverPictureState
            })));
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
};
module.exports["EditorPageCoverPictureEntry"] = $fdbc267ab6414ddb$export$e8a47c72fec9e984;

});

parcelRegister("42HWG", function(module, exports) {

let $2f196ff7187aecc8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2f196ff7187aecc8$var$load("f1Pmi"),
    $2f196ff7187aecc8$var$load("8eqZM"),
    $2f196ff7187aecc8$var$load("5vfHd"),
    $2f196ff7187aecc8$var$load("2Stk7"),
    $2f196ff7187aecc8$var$load("4izLy"),
    $2f196ff7187aecc8$var$load("f35QR"),
    $2f196ff7187aecc8$var$load("eVYW1"),
    $2f196ff7187aecc8$var$load("ls0Um"),
    $2f196ff7187aecc8$var$load("020xd"),
    $2f196ff7187aecc8$var$load("eTBsW"),
    $2f196ff7187aecc8$var$load("bYxCZ"),
    $2f196ff7187aecc8$var$load("6HBYC"),
    $2f196ff7187aecc8$var$load("eDqo1"),
    $2f196ff7187aecc8$var$load("lxiFd"),
    $2f196ff7187aecc8$var$load("1oiJ6"),
    $2f196ff7187aecc8$var$load("huUvS"),
    $2f196ff7187aecc8$var$load("6wr18"),
    $2f196ff7187aecc8$var$load("dlm6q"),
    $2f196ff7187aecc8$var$load("98UJI"),
    $2f196ff7187aecc8$var$load("bTmOC"),
    $2f196ff7187aecc8$var$load("8j9XC"),
    $2f196ff7187aecc8$var$load("6vhrJ"),
    $2f196ff7187aecc8$var$load("fxC6e"),
    $2f196ff7187aecc8$var$load("1Sh6a"),
    $2f196ff7187aecc8$var$load("ffEVr"),
    $2f196ff7187aecc8$var$load("kHOMt"),
    $2f196ff7187aecc8$var$load("jXx9i"),
    $2f196ff7187aecc8$var$load("hvsDR"),
    $2f196ff7187aecc8$var$load("9t4BV"),
    $2f196ff7187aecc8$var$load("i566x"),
    $2f196ff7187aecc8$var$load("7EorR"),
    $2f196ff7187aecc8$var$load("hhss7"),
    $2f196ff7187aecc8$var$load("Wowvf"),
    $2f196ff7187aecc8$var$load("5RR9C"),
    $2f196ff7187aecc8$var$load("h3ABO"),
    $2f196ff7187aecc8$var$load("kC80R"),
    $2f196ff7187aecc8$var$load("gGhXk")
]).then(()=>parcelRequire('4hoOb'));

});


//# sourceMappingURL=EditorPageCoverPictureEntry.5c93eab9.js.map
